import {findMe} from '../fetch/accountApi';
import login from '../fetch/login';
import {logout} from '../fetch/logout';
import {accessDenied, loggedIn, loggedOut} from '../redux/slice/loginSlice';
import {AppDispatch} from '../store';
import {getLoggedInCookie} from './CookieUtil';

export const checkState = (dispatch: AppDispatch): Promise<unknown> => {
    const cookie = getLoggedInCookie();
    const header = new Headers();

    if (cookie)
        header.set('loggedIn', cookie);

    return findMe(dispatch, header).then(json => {
        if (getLoggedInCookie()) {
            return dispatch(loggedIn(json.result));
        }

        // logout if oauth session is not present
        return doLogout(dispatch);
    }).catch((error: Response) => {
        if (!getLoggedInCookie()) {
            return doLogout(dispatch).then(() => doLogin());
        }

        console.error(error);

        if (error.status === 403) {
            // Logged in but not authorized
            return dispatch(accessDenied());
        } else if (error.status === 401) {
            // not logged in
            return doLogin();
        } else if (error.status === 406) {
            // user has switched
            return doLogout(dispatch).finally(() => checkState(dispatch));
        }

        return doLogout(dispatch);
    });
};

const doLogout = async (dispatch: AppDispatch) => {
    window.sessionStorage.setItem('notLoggedInLocation', JSON.stringify(window.location.href));
    try {
        return await logout(dispatch);
    } finally {
        dispatch(loggedOut());
    }
};

export const doLogin = async () => {
    window.sessionStorage.setItem('notLoggedInLocation', window.location.href);
    await login();
    window.location.href = window.environment.loginUrl;
};